export const isAlreadyExists = ({ prevItems, currentItem, bundle }) => {
  return bundle
    ? prevItems.find(
        (cartItem) => parseInt(cartItem.BundleId) === currentItem.id
      )
    : prevItems.find(
        (cartItem) => parseInt(cartItem.CourseId) === currentItem.ID
      );
};

export const handleAddToCart = ({ prevItems, currentItem }) => {
  const cartItems = isAlreadyExists({ prevItems, currentItem })
    ? prevItems
    : [
        ...prevItems,
        {
          ...currentItem,
        },
      ];
  localStorage.setItem("cartItems", JSON.stringify(cartItems));
  return cartItems;
};

export const handleRemoveCartItem = ({ prevItems, cartItem }) => {
  const cartItems = prevItems.filter((item) => item.ID !== cartItem.ID);
  localStorage.setItem("cartItems", JSON.stringify(cartItems));
  return cartItems;
};

export const isCourseInCart = (loggedIn, prevItems, course, bundle) => {
  return prevItems && loggedIn
    ? isAlreadyExists({
        prevItems: prevItems,
        currentItem: course,
        bundle: bundle,
      })
    : false;
};
